<template>
  <div class="overlay list">
    <div class="category" v-for="category in categories" :key="category">
      <div class="category-title">
        {{ category }}
      </div>
      <article
        ref="article"
        v-for="project in filter(projects, category)"
        :key="project.uid"
        @click="goTo(project.files[0].filename, project.category)"
      >
        {{ project.title }}
      </article>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "index",
  computed: {
    ...mapState(["projects"])
  },
  data() {
    return {
      categories: ["paintings", "drawings", "other", "editorial", "curatorial"]
    };
  },
  methods: {
    filter(array, filter) {
      return array.filter(project => project.category === filter);
    },
    goTo(file, category) {
      this.$root.$emit("goTo", file, category);
      this.$router.push({
        name: category
      });
    }
  }
};
</script>

<style lang="scss">
.category {
  margin-bottom: var(--lh);
  .category-title {
    text-transform: capitalize;
  }
  article {
    cursor: pointer;
  }
}
</style>
